import type {
  TSimulacaoGrupoIntermediariasPosConclusao,
  TSimulacaoGrupoMensaisBase,
} from '@/domain/simulador/types/simulacao.type'
import { ProcessadorParcelasHelper } from '@/features/simulador/shared/domain/processador-parcelas.helper'
import type { IFluxoPagamento } from '@/http/get-fluxo-pagamentos-simulacao.service'
import type {
  TGrupoIntermediarias,
  TGrupoMensais,
  TGrupoParcelas,
} from '@/utils/calculadora-valores-totais/processador-valores-decimal'
import { formatToBRL } from '@/utils/currency.utils'

export class CalculadorFluxoDePagamentoSacocVParcelado {
  constructor(
    private readonly entradas?: TGrupoParcelas,
    private readonly mensais?: TSimulacaoGrupoMensaisBase,
    private readonly intermediarias?: TGrupoIntermediarias[],
    private readonly posConclusao?: TGrupoMensais,
    private readonly intermediariasPosConclusao?: TSimulacaoGrupoIntermediariasPosConclusao,
  ) {}

  calcular(): IFluxoPagamento[] {
    const todasParcelas = [
      ...ProcessadorParcelasHelper.processarEntradas(this.entradas),
      ...ProcessadorParcelasHelper.processarMensais(this.mensais),
      ...ProcessadorParcelasHelper.processarIntermediarias('Intermediarias', this.intermediarias),
      ...ProcessadorParcelasHelper.processarPosConclusao(this.posConclusao),
      ...ProcessadorParcelasHelper.processarIntermediarias(
        'IntermediariasPosConclusao',
        this.intermediariasPosConclusao,
      ),
    ]

    return ProcessadorParcelasHelper.agruparEFormatar(todasParcelas, formatToBRL)
  }
}
